export default __webpack_public_path__ + "static/media/O-128.7b657b42.png";